<wiz-vgroup #vgDetailZone width="100%" height="100%" horizontalAlign="center" gap="2" padding="5px" class="section-container">
  <wiz-hgroup width="100%" verticalAlign="center" padding="3px">
    <wiz-label #lbTitle width="100%" class="smallTitleLabel"></wiz-label>
    <wiz-icon class="image-purple" (click)="doCancel()">close</wiz-icon>
  </wiz-hgroup>

    <!-- gestion du texte libre -->
    <wiz-hgroup #gpHhtmlEditor [visible]="false" width="100%" height="100%">
      <angular-editor 
       id="aeBaseline"
       #ae 
       [(ngModel)]="htmlContent" width="100%" height="100%"></angular-editor>
    </wiz-hgroup>
  
    <!-- gestion des actions connect libres -->
    <wiz-vgroup #gpConnect [visible]="false" width="100%" height="100%">
      <wiz-dropdown
          #ddConnect
          width="150px"
          [wizLabelField]="'trsLabel'"
          [wizLabel]="'$.pivot.edit.field.field.$'"></wiz-dropdown>
      <wiz-button #btConnect class="button-connect" width="100%"></wiz-button>
    </wiz-vgroup>
  
    <!-- gestion des images libres -->
    <wiz-hgroup #imgGp [visible]="false" width="100%" height="100%">
      <wiz-image
        #img
        tabindex="0"
        height="100%"
        width="100%"
        class="img-picker"
        [useHandCursor]="true"
        (click)="clickForUpload()"
        (keydown)="keydownForUpload($event)"
      ></wiz-image>
    </wiz-hgroup>

      
  <!-- gestion du label -->
  <wiz-vgroup  #gpLabel [visible]="false" width="100%" class="section-container" padding="5px" gap="0">
    <wiz-label [wizLabel]="'$.common.label.$'" class="smallTitleLabel"></wiz-label>
    <wiz-hgroup width="100%">
      <wiz-text-input #tiLabel width="100%" wizShowLabel="false" [wizMaxChars]="255"> </wiz-text-input>
      <wiz-text-input #tiGrp width="100%" [wizLabel]="'$.pivot.edit.field.groupmember.$'" [wizMaxChars]="255"> </wiz-text-input>
      <wiz-checkbox #cbShowLabel [visible]="!isFake" [wizLabel]="'$.field.show.label.$'"></wiz-checkbox>
    </wiz-hgroup>  </wiz-vgroup>

  <!-- gestion du format de données, du champ en cas de FD, et de la fonction d'aggregat -->
  <wiz-hgroup #gpFormat [visible]="false" verticalAlign="center" width="100%" class="section-container" padding="5px" gap="5">
      <wiz-dropdown
        #ddFormat
        width="150px"
        [wizLabelField]="'trsLabel'"
        [wizLabel]="'$.pivot.edit.field.format.$'"></wiz-dropdown>

      <wiz-dropdown #ddField [visible]="false"
        width="150px"
        [wizLabel]="'$.pivot.edit.field.field.$'"
        [wizLabelField]="'trsLabel'"></wiz-dropdown>
      <wiz-dropdown
        #ddStyle
        width="150px"
        [wizLabelField]="'trsLabel'"
        [wizLabel]="'$.pivot.edit.field.style.$'"></wiz-dropdown>  

    <wiz-vgroup>
      <wiz-checkbox #cbReadOnly [wizLabel]="'$.pivot.edit.field.readonly.$'"></wiz-checkbox>
      <wiz-checkbox #cbNoClone [wizLabel]="'$.pivot.edit.field.noclone.$'"></wiz-checkbox>
    </wiz-vgroup>


  </wiz-hgroup>
  

  <!-- gestion du champ visible en cas de FD -->
  <!-- <wiz-vgroup #gpField [visible]="false" width="100%" class="section-container" padding="5px" gap="0">
    <wiz-label [wizLabel]="'$.pivot.edit.field.field.$'" class="smallTitleLabel"></wiz-label> -->

  <!-- </wiz-vgroup> -->

  <!-- gestion des champs visibles pour la sélection de FD -->
  <wiz-vgroup #gpFields [visible]="false" width="100%" height="100%" class="section-container" padding="5px" gap="0">
    <wiz-label [wizLabel]="'$.pivot.edit.field.fields.$'" 
    class="smallTitleLabel"></wiz-label>
    <wiz-ag-grid #agGrid width="100%" height="100%" 
    class="ag-theme-alpine"
    [gridOptions]="gridOptions"
    [wizDatasource]="fieldsDS" 
    [columnDefs]="columns"
    [wizRowSelection]="'multiple'"
    [dndConfig]="dndConfig"
    ></wiz-ag-grid>
  </wiz-vgroup>

  <!-- contenu avancé (settings sur workflow) -->
  <wiz-vgroup #advancedTab [visible]="false" class="section-container" width="100%" height='100%'>    
      <wiz-text-area
        #taSettings id="taSettings"
        [wizLabel]="'$.mesure.settings.$'"
        width="100%"
        height="100%"
        [wizMaxChars]="2000"
      ></wiz-text-area>
  </wiz-vgroup>

  <wiz-spacer [visible]="!isFake && !isFD()" height="100%"></wiz-spacer>
  <wiz-hgroup width="100%" height="45px" padding="5px" horizontalAlign="end">
    <wiz-button
      #btnSave
      [wizLabel]="'$.common.save.modification.$'"
      [wizIcon]="'icon-arrow-right'"
      (click)="save()"
      [iconPlacement]="'right'"
    ></wiz-button>
    <wiz-button
      #btnCancel
      class="cancel-button"
      [wizIcon]="'icon-arrow-left'"
      (click)="doCancel()"
      [wizLabel]="'$.common.cancel.modification.$'"
    ></wiz-button>
  </wiz-hgroup>
</wiz-vgroup>
